export default __webpack_public_path__ + "static/media/fa-solid-900.6606667d.eot";